import React from 'react';
import styled from 'styled-components';
import { Flex } from 'rebass/styled-components';

function DividerWithText({ children, ...props }) {
  return (
    <Flex alignItems='center' {...props}>
      <Border />
      <Content>{children}</Content>
      <Border />
    </Flex>
  );
}

export default DividerWithText;

const Border = styled.div`
  border-bottom: ${({ theme }) => `1px solid ${theme.colors?.greyBorder}`};
  width: 100%;
`;

const Content = styled.div`
  padding: 0 19px 0 19px;
  color: ${({ theme }) => theme.colors?.grey[60]};
  font-size: 11px;
  line-height: 16px;
  font-weight: bold;
`;
